import React from 'react';
import { Modal, Button } from 'antd';
import { ModalTitle } from '../../../components/text/Titles';
import BatchUploader from '../../../common/BatchUploader';

type Props = {
  visible: boolean;
  onClose: () => any;
  onDocumentUploaded: () => any;
  modelId: number | null;
  title: string;
  datasetVersion: string;
};
const DocumentUpload = (props: Props) => {
  const { visible, onClose, onDocumentUploaded, title, datasetVersion, modelId } = props;

  const onUpload = () => {
    onDocumentUploaded();
    onClose();
  };
  return (
    <Modal
      visible={visible}
      title={<ModalTitle>{title}</ModalTitle>}
      onCancel={onClose}
      footer={
        <Button type="default" onClick={onClose}>
          Cancel
        </Button>
      }>
      <div>
        <BatchUploader
          datasetVersion={datasetVersion}
          modelId={modelId}
          multiple={true}
          noInference={true}
          onBatchUploaded={onUpload}
        />
      </div>
    </Modal>
  );
};

export default DocumentUpload;
